import { faEye } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Modal, Row, Table } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import Dialog from '../../Dialog';
import LoginHeader from '../../Login_header';
import Menu from '../../Menu';
import * as Picklist from '../../Picklist';
import * as Common from "../../Common";


function TCS_eligibility_report() {
    let OVERSEASEEDUCATION = '13';
    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const startDate = sessionStorage.getItem('startDate');
    const endDate = sessionStorage.getItem('endDate');

    const [userRight, setUserRight] = useState([]);
    const [onceRun, setOnceRun] = useState(false);
    const [scrMode, setScrMode] = useState("");

    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [pan, setPan] = useState('');
    const [purpose, setPurpose] = useState(null);
    const [purposeCode, setPurposeCode] = useState();
    const [traAmount, setTraAmount] = useState(0);
    const [isLoan, setIsLoan] = useState('N')
    const [disAmount, setDisAmount] = useState();
    const [list, setList] = useState([]);
    const [tcsTax, setTcsTax] = useState(0);
    const [totalTaxableAmount, setTotalTaxableAmount] = useState(0);
    const [totalPreviousAmount, setTotalPreviousAmount] = useState(0);



    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'TCS_ELIGIBILITY'], function (result) {
                let resp = JSON.parse(result);
                if (resp?.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);



    const handlePurposeChange = (value) => {
        setPurpose(value);
        const purpose = value.id.split('^');
        setPurposeCode(purpose[1]);
    }
    const handleReset = () => {
        setPan("");
        setPurpose(null);
        setPurposeCode("");
        setTraAmount(0);
        setIsLoan('L');
        setDisAmount("");
        setTcsTax(0)
        setTotalPreviousAmount(0)
        setTotalTaxableAmount(0)
        setList([]);
    }
    const handleTcsEligibility = () => {
        $('.loader').show();
        let msg = [];
        msg.push(Common.getMessage("MSG0006"));
        !pan && msg.push(' Pan Number Required');
        !purpose && msg.push(' Purpose Required');
        !traAmount && msg.push(' Amount Required');
        // (purposeCode === OVERSEASEEDUCATION && isLoan) && msg.push(' Loan Required');
        (purposeCode === OVERSEASEEDUCATION && isLoan === 'Y' && !disAmount) && msg.push(' Disbersed Amount Required');

        if (msg.length > 1) {
            $('.loader').hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                pan: pan,
                traAmount: traAmount,
                // purpose: purpose,
                purposeCode: purposeCode,
                isLoan: isLoan,
                disAmount: disAmount
            }
            Common.callApi(Common.apiTCS_eligibily_report, [sid, 'checkEligibility', JSON.stringify(obj)], result => {
                $('.loader').hide();
                const response = JSON.parse(result);
                if (response.status) {
                    setList(response.data.data)
                    setTcsTax(response.data.tcs);
                    response.data.data.length > 0 && setTotalPreviousAmount(traAmount)
                    setTotalTaxableAmount(response.data.tcsTeaxable);
                } else {
                    setMsgText(response.msg)
                    setMsgBox(true);
                }
            })
        }





    }
    return (
        <div>
            <LoginHeader />
            <Menu />

            <Container fluid>
                <>
                    {scrMode === "" ?
                        <>
                            <Row>
                                <Col>
                                    <h2>TCS Eligibility Report </h2>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="col-md-3 col-6">
                                    <Form.Group>
                                        <Form.Label>Pan Number </Form.Label>
                                        <Form.Control type="text"
                                            placeholder="Pan Number"
                                            maxLength={11}
                                            autoComplete="off"
                                            value={pan}
                                            onChange={(e) => setPan(e.target.value.toUpperCase())}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Purpose</Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={purpose}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={Picklist.fetchPurposePicklist}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handlePurposeChange}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col>
                                <Col className="col-md-3 col-6">
                                    <Form.Group>
                                        <Form.Label>Current Transaction Amount </Form.Label>
                                        <Form.Control type="text"
                                            placeholder="Transaction Amount"
                                            autoComplete="off"
                                            maxLength={7}
                                            value={traAmount}
                                            onChange={(e) => setTraAmount(e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                {
                                    purposeCode === OVERSEASEEDUCATION &&
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>Loan</Form.Label>
                                            <Form.Select value={isLoan} onChange={e => setIsLoan(e.target.value)}>
                                                <option value="N">No</option>
                                                <option value="Y">Yes</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                }
                                {purposeCode === OVERSEASEEDUCATION && isLoan === 'Y' &&
                                    <Col className="col-md-3 col-6">
                                        <Form.Group>
                                            <Form.Label>Disburshed Amount </Form.Label>
                                            <Form.Control type="text"
                                                placeholder="Disburshed Amount"
                                                autoComplete="off"
                                                maxLength={7}
                                                value={disAmount}
                                                onChange={(e) => setDisAmount(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                }

                            </Row>
                            &nbsp;
                            <Row>
                                <Col>
                                    <Button variant='outline-secondary' className='buttonStyle' size='sm' onClick={handleTcsEligibility}>Get TCS Eligibility Report</Button>&nbsp;
                                    <Button variant='outline-secondary' className='buttonStyle' size='sm' onClick={handleReset}>Reset</Button>
                                </Col>
                            </Row>
                            &nbsp;
                            {/* table  */}
                            <Row>
                                <Table responsive bordered striped >
                                    <thead>
                                        <tr>
                                            <th>&nbsp;</th>
                                            <th>Srno</th>
                                            <th>Date</th>
                                            <th>Location</th>
                                            <th>Total Forex</th>
                                            <th>Is TCS Applicable</th>
                                            {/* <th>Report Type</th> */}
                                            <th>&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            list.map((item, index) => (
                                                <>
                                                    <tr key={index}>
                                                        <td>&nbsp;</td>
                                                        <td>{item.hdr_srno}</td>
                                                        <td>{Common.dateDMYStr(item.hdr_date)}</td>
                                                        <td>{item.hdr_location + " " + item.entity_name}</td>
                                                        <td>{item.hdr_forex_total}</td>
                                                        <td>{item.hdr_tcs_amount > 0 ? "Yes" : "No"}</td>
                                                    </tr>
                                                </>
                                            ))
                                        }
                                    </tbody>
                                </Table>
                            </Row>
                            <Row>
                                <Col className="col-md-3 col-6">
                                    <Form.Group>
                                        <Form.Label>Total Previous Amount </Form.Label>
                                        <Form.Control type="text"
                                            value={list[0]?.total_tcs_amount}
                                            disabled
                                        />
                                    </Form.Group>
                                </Col>
                                <Col className="col-md-3 col-6">
                                    <Form.Group>
                                        <Form.Label>Current Amount </Form.Label>
                                        <Form.Control type="text"
                                            value={totalPreviousAmount}
                                            disabled
                                        />
                                    </Form.Group>
                                </Col>
                                <Col className="col-md-3 col-6">
                                    <Form.Group>
                                        <Form.Label>Total Taxable Amount </Form.Label>
                                        <Form.Control type="text"
                                            value={totalTaxableAmount}
                                            disabled
                                        />
                                    </Form.Group>
                                </Col>
                                <Col className="col-md-3 col-6">
                                    <Form.Group>
                                        <Form.Label>TCS Tax </Form.Label>
                                        <Form.Control type="text"
                                            value={tcsTax}
                                            disabled
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </> : null}
                </>
            </Container>

            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>


            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
        </div>
    )
}

export default TCS_eligibility_report
